import * as React from 'react';
import {useContext, useEffect, useRef} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {CircularProgress} from "@mui/material";
import {ProblemContext} from "../components/Problem";

import css from "../css/video.module.css";

const Video = () => {
    const videoRef = useRef(null);
    const {videoURL} = useContext(ProblemContext);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        if (!videoURL) return;

        const video = videoRef.current;
        video.ontimeupdate = () => {
            video.style.display = "inline";
            loading && setLoading(false);
        }

        video.src = videoURL;
        video.play();
    }, [videoURL])

    return (
        <div className={css.container}>
            <video style={{display: "none"}} ref={videoRef} controls={true}/>
            {loading && (
                <div className={css.loading}>
                    <CircularProgress/>
                    <p>Пожалуйста, подождите...</p>
                </div>
            )}
        </div>
    )
}

export const VideoDialogs = ({children}) => {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <div onClick={() => setOpen(true)}>{children}</div>
            <Dialog fullWidth={true} onClose={() => setOpen(false)} open={open}>
                <IconButton title={"Закрыть"} onClick={() => setOpen(false)} sx={{
                    zIndex: 1000000,
                    position: 'absolute',
                    right: "2px",
                    top: "2px",
                    padding: 0.2,
                    color: "rgba(0,0,0,0.8)",
                    backgroundColor: "rgba(100,100,100,0.2)",
                    '&:hover': {backgroundColor: "rgba(100,100,100,0.3)"},
                    '&:active': {backgroundColor: "rgba(100,100,100,0.3)"}
                }}><CloseIcon/></IconButton>
                <Video/>
            </Dialog>
        </>
    );
}
